import Vue from 'vue'
import moment from "moment";
import accounting from "accounting";
import VuetableFieldSequence from 'vuetable-2/src/components/VuetableFieldSequence.vue'
import VuetableFieldCheckbox from 'vuetable-2/src/components/VuetableFieldCheckbox.vue'
Vue.component('vuetable-field-checkbox', VuetableFieldCheckbox)

export default [
  {
    name: "createdOn",
    title: 'Date',
    width: "10%",
    sortField: "createdOn",
    formatter(value) {
      if (value) {
        return moment(new Date(value)).utc().format("YYYY-MM-DD");
      }
    }
  },
  {
    name: "custom-description",
    title: 'Description',
    width: "30%",
    sortField: "description"
  },
  // {
  //   name: "custom-actions",
  //   title: "Actions",
  //   width: "20%"
  // }

]